import o from"./index.module.scss.js";const s=o;export{s as TableTheme};
//# sourceMappingURL=index.js.map
